import moment from "moment";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_TIME_FORMAT } from "src/common/constants";
import {
  REPORT_STATUS_CLOSED,
  REPORT_STATUS_DELETED,
  REPORT_STATUS_PENDING_DELETION,
} from "src/components/constants/Reports";

const NON_EDITABLE_DEADLINE_STATUSES = [
  REPORT_STATUS_CLOSED,
  REPORT_STATUS_DELETED,
  REPORT_STATUS_PENDING_DELETION,
];

const dateUtils = new DateUtils();

export const formatDsrApiDateTime = (date) =>
  moment(date).startOf("day").format("YYYY-MM-DD HH:mm:ss");

export const parseDsrDate = (value) => {
  if (!value) {
    return null;
  }

  const strict = moment(value, "YYYY-MM-DD HH:mm:ss", true);
  if (strict.isValid()) {
    return strict;
  }

  const loose = moment(value);
  return loose.isValid() ? loose : null;
};

export const formatDeadlineDate = (value) => {
  if (!parseDsrDate(value)) {
    return "—";
  }

  return dateUtils.convertDateToDate(value, INTERNATIONAL_DATE_TIME_FORMAT);
};

export const deadlinesDiffer = (original, effective) => {
  const originalDate = parseDsrDate(original);
  const effectiveDate = parseDsrDate(effective);

  if (!originalDate || !effectiveDate) {
    return false;
  }

  return !originalDate.isSame(effectiveDate);
};

export const canEditDsrDeadline = (report) => {
  if (!report) {
    return false;
  }

  if (
    report.is_read_only_analyst ||
    report.is_deleted_content ||
    report.deleted_by_name
  ) {
    return false;
  }

  return !NON_EDITABLE_DEADLINE_STATUSES.includes(Number(report.status));
};

export const getWaitingDurationLabel = (startedAt, t) => {
  const started = parseDsrDate(startedAt);
  if (!started) {
    return "—";
  }

  const days = moment().diff(started, "days");
  if (days < 1) {
    return t("Less than 1 day");
  }

  if (days === 1) {
    return `1 ${t("day")}`;
  }

  return `${days} ${t("days")}`;
};
